(function (global) {
    function catchErr(code) {
        if (code == '401' || code == 'course_0000_0002') {
            // global.Vue.prototype.$message.error('未登录')
        }
        // if (code == 403) {
        //     location.replace('/learn/error/403')
        // }
    }
    let headers = {}
    if (localStorage.getItem('x-cas-token-app') || '') {
        headers = {
            'x-cas-token': localStorage.getItem('x-cas-token-app') || ''
        }
    }
    /**
     * ajax请求
     */
    let ajax = {
        get(url, params = {}) {
            if (window.courseSemester && url.includes('/forumservice')) { params.course_semester = window.courseSemester }
            return new Promise((resolve, reject) => {
                jQuery.ajax({
                    url,
                    type: 'GET',
                    data: params,
                    xhrFields: {
                        withCredentials: true //允许跨域带Cookie
                    },
                    crossDomain: true,
                    // headers: { auth: document.cookie },
                    headers,
                    success(res) {
                        // console.log(url, res)
                        catchErr(res.statusCode || res.errorCode || res.status)
                        resolve(res)
                    },
                    error(err) {
                        console.error(err)
                        reject(err)
                    }
                })
            })
        },
        post(url, data = {}, params = {}) {
            if (window.courseSemester && url.includes('/forumservice')) { data.course_semester = window.courseSemester }
            const queryString = new URLSearchParams(params).toString();
            if (queryString) {
                url += `?${queryString}`;
            }
            return new Promise((resolve, reject) => {
                jQuery.ajax({
                    url,
                    type: 'POST',
                    contentType: "application/json; charset=utf-8",
                    data: JSON.stringify(data),
                    xhrFields: {
                        withCredentials: true //允许跨域带Cookie
                    },
                    crossDomain: true,
                    // headers: { auth: document.cookie },
                    headers,
                    success(res) {
                        // console.log(url, res)
                        // catchErr(res.statusCode || res.errorCode || res.status)
                        resolve(res)
                    },
                    error(err) {
                        console.error(err)
                        reject(err)
                    },

                })
            })
        },
        postQuery(url, params) {
            if (params) url += '?';
            const temp = Object.keys(params);
            temp.map((item, index) => {
                url += item + '=' + params[item] + (index == temp.length - 1 ? '' : '&');
            })
            if (window.courseSemester && url.includes('/forumservice')) { params.course_semester = window.courseSemester }
            return new Promise((resolve, reject) => {
                jQuery.ajax({
                    url,
                    type: 'POST',
                    contentType: "application/json; charset=utf-8",
                    xhrFields: {
                        withCredentials: true //允许跨域带Cookie
                    },
                    crossDomain: true,
                    // headers: { auth: document.cookie },
                    headers,
                    success(res) {
                        // console.log(url, res)
                        // catchErr(res.statusCode || res.errorCode || res.status)
                        resolve(res)
                    },
                    error(err) {
                        console.error(err)
                        reject(err)
                    }
                })
            })
        },

        delete(url, data = {}) {
            if (window.courseSemester && url.includes('/forumservice')) { data.course_semester = window.courseSemester }
            return new Promise((resolve, reject) => {
                jQuery.ajax({
                    url,
                    type: 'DELETE',
                    contentType: "application/json; charset=utf-8",
                    data: JSON.stringify(data),
                    xhrFields: {
                        withCredentials: true //允许跨域带Cookie
                    },
                    crossDomain: true,
                    // headers: { auth: document.cookie },
                    headers,
                    success(res) {
                        // console.log(url, res)
                        catchErr(res.statusCode || res.errorCode)
                        resolve(res)
                    },
                    error(err) {
                        console.error(err)
                        reject(err)
                    }
                })
            })
        },

        blob(url, data = {}) {
            if (window.courseSemester && url.includes('/forumservice')) { data.course_semester = window.courseSemester }
            return new Promise((resolve, reject) => {
                const xhr = new XMLHttpRequest();
                Object.keys(headers).map(key => {
                    xhr.setRequestHeader(key, headers[key]);
                })
                xhr.open('POST', url, true);
                xhr.responseType = "blob";
                xhr.setRequestHeader("Content-type", "application/json;charset=utf-8"); //这个看后端接口情况决定要不要写
                xhr.onload = () => {
                    resolve(xhr.response)
                }
                xhr.send(JSON.stringify(data));
            })
        }
    }

    global.ajax = ajax

    global.API = {}
    /**
     * 获取用户信息
     */
    API.reqUserInfo = data => ajax.get('/learn/login/info', data, '')

    /**
     * 用户下拉权限管理
     */
    API.reqRoleModule = data => ajax.get('/unifiedplatform/v1/user/rolemodule')

    /**
     * 获取首页门户权限
     *
     */
    API.reqPermissionList = data => ajax.get('/unifiedplatform/v1/app/app/module/list', data)

    /**
     * 退出登录
     */
    API.reqLoginOut = data => ajax.get('/unifiedlogin/v1/loginmanage/loginout/go')

    /**
     * 课堂笔记管理
     */
    /**
     * 获取笔记列表
     * @param {string} courseId
     * @param {string} sectionId
     * @param {string} noteType
     * @param {string} pageIndex
     * @param {string} pageSize
     */
    API.reqCourseNotes = data => ajax.get('/edudatacenter/v1/learning-note-service/get', data)

    /**
     * 课程添加收藏
     * @param {string} courseId
     * @param {string} courseName
     * @param {array} teachers
     * @param {array} collegeName
     * @param {string} courseType
     * @param {string} courseCover
     */
    API.reqCourseCollect = data => ajax.post('/learn/v1/learningsituation/collection/course', data)
    /**
     * 课程取消收藏
     * @param {string} courseId
     */
    // API.reqCourseUncollect = data => ajax.post(`/cvod/v1/learningsituation/cancel/collection/course?courseId=${data.courseId}`, data)
    API.reqCourseUncollect = data => ajax.post(`/learn/v1/learningsituation/cancel/collection/course?courseId=${data.courseId}`, data)
    /**
     * 获取收藏状态或数量
     * @param {string} courseId
     */
    API.reqCourseCollectMe = data => ajax.get(`/learn/v1/learningsituation/collection/course`, data)

    /**
     * 收藏教学内容
     */
    API.reqTeachingResourceCollect = data => ajax.post('/learn/v1/learningsituation/collection/course/resource', data)

    /**
     * 获取教学内容收藏状态
     */
    API.reqIfCollectTeachingResource = data => ajax.get('/learn/v1/learningsituation/whether/collection/resource', data)

    /**
     * 取消收藏教学内容
     */
    API.reqTeachingResourceUncollect = data => ajax.post('/learn/v1/learningsituation/cancel/collection/resource?resourceId=' + data.resourceId, data)

    /**
     * 课程点赞
     * @param {string} courseId
     * @param {string} courseType
     * @param {string} likeTime
     * @param {string} userCode
     */
    API.reqCourseLikeAdd = data => ajax.post('/learn/v1/learningsituation/like/course', data)
    /**
     * 查询点赞数量
     * @param {*} courseId
     */
    API.reqCourseLikeNumber = data => ajax.get('/learn/v1/learningsituation/count/like/size', data)
    /**
     * 课程取消点赞
     * @param {*} courseId
     */
    API.reqCourseLikeCalcel = data => ajax.get('/learn/v1/learningsituation/cancel/like/course', data)
    /**
     * 获取点赞状态
     * @param {*} courseId
     */
    API.reqCourseLikeStatus = data => ajax.get('/learn/v1/learningsituation/is/like/course', data)

    /**
     *加入课程
     */
    // API.reqCourseJion = data => ajax.post(`/cvod/v1/learningsituation/join?courseId=${data.courseId}&courseType=${data.courseType}`)
    API.reqCourseJion = data => ajax.post(`/learn/v1/learningsituation/join`, data)
    /**
     * 统计加入数量
     */
    API.reqCourseJoinNumber = data => ajax.post('/learn/v1/learningsituation/course/view', data)

    /**
     * 笔记
     */
    /**
     * 添加笔记
     * @param courseId
     * @param courseName
     * @param courseType
     * @param imageBase64
     * @param note
     * @param noteType
     * @param pointIn
     * @param pointOut
     * @param remark
     */
    API.reqCourseNoteAdd = data => ajax.post('/edudatacenter/v1/learning-note-service/create', data)
    /**
     * 更新笔记
     */
    API.reqCourseNoteUpdate = data => ajax.post('/edudatacenter/v1/learning-note-service/update', data)
    /**
     * 新增、保存笔记
     * @param {*} data
     * @returns
     */
    API.reqUpsertNote = data => ajax.post('/edudatacenter/v1/learning-note-service/upsert', data)
    /**
     * 获取笔记列表
     */
    API.reqCourseNoteList = data => ajax.get(`/edudatacenter/v1/learning-note-service/get`, data)
    /**
     * 删除笔记
     * @param {string} data
     */
    API.reqCourseNoteDel = data => ajax.delete('/edudatacenter/v1/learning-note-service/batch/delete', data)
    /**
     * 知识点
     */
    /**
     * 获取知识点列表
     * @param contentId
     * @param metadataType model_sobey_cata_sequencemeta
     */
    API.reqKnowladgePointList = data => ajax.post('/rman/v1/cata/sequencemeta/select', data)
    /**
     * 获取语音文本列表
     * @param contentId
     * @param metadataType model_sobey_smart_voice_
     */
    API.reqVoiceTextList = data => ajax.post('/rman/v1/smart/voice/select', data)
    /**
     * 获取是否有课程地图
     * @param contentId
     * */
    API.reqHasCourseMap = data => ajax.get(`/learn/v1/course/course/map/${data.courseId}`, data)
    /**
     * 查看绑定知识图谱
     * @param contentId
     * */
    API.reqCourseMap = data => ajax.post(`/learn/m1/course/get/map?courseId=${data.courseId}&isShow=${data.isShow}&courseSemester=${data.courseSemester}`, data)

    /**
     * 课程评论
     */
    /**
     * 获取评论列表
     * @param {string} courseId
     * @param {string} content
     * @param {number} star
     */
    API.reqCourseEvaluationList = data => ajax.get(`/learn/v1/evaluation`, data)
    /**
     * 发表评论
     * @param {string} courseId
     * @param {number} page
     * @param {number} size
     */
    API.reqPublishEvaluation = data => ajax.post(`/learn/v1/evaluation`, data)
    /**
     * 获取课程评价总览
     * @param id
     */
    API.reqTotalEvaluation = courseId => ajax.get(`/learn/v1/evaluation/${courseId}`)

    /**
     * 课堂回看
     */
    /**
     * 获取视频资源列表信息
     * @param {string} schedule_id 查询sectionId
     */
    API.reqVideoreviewSection = data => ajax.get('/rman/v1/search/relation/video', data)
    /**
     * 课堂回看
     */
    /**
     * 获取视频资源列表信息
     * @param {string} scheduleIds 查询sectionId
     */
    API.reqVideoreviewSections = data => ajax.post('/rman/v1/search/relation/videos', data)
    /**
     * 获取课堂回看视频详情
     * @param {array} data contentid
     */
    API.reqVidoreviewDetail = data => ajax.post('/rman/v1/entity/download/fileinfo', data)

    /**
     * 获取课堂回看详情页内容
     * */

    API.reqVidoreviewInfo = data => ajax.get('/learn/v1/course/recording/video/info', data)

    /**
     * 开启关闭时间片段
     * @param {string} courseId
     * @param {number} onFragment 0-关闭 1-开启
     * @param {array} videoIds
     */
    API.reqOpenCloseFragment = data => ajax.post('/learn/v1/course/turnPartFragment', data)

    /**
     * 在线课堂添加时间片段
     * @param {string} courseId
     * @param {number} startTime
     * @param {number} endTime
     * @param {array} videoIds
     */
    API.reqAddFragment = data => ajax.post('/learn/v1/course/addTimeFragment', data)

    /**
     * 获取时间片段
     * @param {string} courseId
     * @param {array} videoIds
     */
    API.reqGetFragment = data => ajax.post('/learn/v1/course/getTimeFragment', data)

    /**
     * 删除时间片段
     * @param {string} id
     */
    API.reqDeleteFragment = data => ajax.get('/learn/v1/course/deleteTimeFragment', data)

    /**
     * 获取语音转写语言列表
     */
    API.reqTraslateLanguageList = data => ajax.get('/aiiltsmanage/wsman/TsConfig/', data)

    /**
     * 语音转写
     */
    /**
     * 开启直播语音转写
     * @param {string} live_id
     * @param {boolean} ts
     * @param {boolean} tts
     * @param {string} address
     * @param {string} kfr
     * @param {Array} kto
     *
     */
    API.reqLiveVoiceToTextOpen = data => ajax.get(`/learn/live/start`, data, '')
    // API.reqLiveVoiceToTextOpen = data => ajax.post(`/aiiltsmanage/wsman/RtASR/start/`, data, '')
    /**
     * 关闭直播语音转写
     * @param {string} live_id
     */
    // API.reqLiveVoiceToTextClose = data => ajax.get(`/learn/live/stop`, data, '')
    // API.reqLiveVoiceToTextClose = data => ajax.get(`/aiiltsmanage/wsman/RtASR/stop/`, data, '')

    /**
     * 批量关闭语音转写
     */
    API.reqLiveVoiceToTextClose = data => ajax.post(`/learn/live/stop`, data)

    /**
     *获取用户权限列表
     * @param {array} data
     */
    API.reqModuleParameterList = data => ajax.post('/unifiedplatform/v1/app/app/module/parameter/list', data)

    /**
     * 更新学习进度
     */
    API.reqUpdateLearnStatus = data => ajax.get('/learn/v1/learningsituation/status', data)

    /**
     * 获取学习进度
     */
    API.reqLearnStatus = data => ajax.get('/learn/v1/learningsituation', data)

    /**
     * 创建学习记录
     */
    API.reqCreateLearnStatus = data => ajax.post('/learn/v1/learningsituation', data)

    /**
     *  获取课程设置
     */
    API.reqCourseSetting = data => ajax.get('/learn/v1/teaching/course/get/course/seting', data)

    /**
     *  记录学习时长
     */
    API.reqUpdateLearnTime = data => ajax.post('/learn/v1/statistics/course/learntime', data)

    /**
     * 心跳接口
     * */
    API.reqHeartBeat = data => ajax.get(`/unifiedplatform/v1/user/heartbeat`, data)
    /**
     * 获取课程页分类
     * */
    API.reqCourseCategories = data => ajax.get('/learn/courseSearch', data)
    /**
     * 获取课程直播状态
     * */
    API.reqCourseLiveInfo = data => ajax.get(`/learn/live/course/info`, data)
    /**
     * 获取活动直播状态
     * */
    API.reqActivityLiveInfo = data => ajax.get(`/learn/live/activity/info`, data)
    /**
     * 图书馆token
     * */
    API.reqLibToken = data => ajax.get(`/unifiedplatform/v1/user/token`, data)
    /**
     * 获取文献库内嵌html
     * */
    API.reqLibHtml = data => ajax.get(`/learn/resource/sourcelistfordc`, data)
    /**
     * 获取未读问答数量
     * */
    API.reqQsCount = data => ajax.get(`/forumservice/ForumBase/unread_count/`, data)

    /**
     * 获取所属学期
     */
    API.reqSemesterList = () => ajax.get("/learn/v1/dropdownbox/semester/manage/list")

    /**
     * 获取热门标签
     */
    API.reqGetHotTag = (data) => ajax.get("/learn/v1/course/tag/second/subject", data)

    /**
     * 查询视频播放记录
     */
    API.getVideoHistory = (data) => ajax.get('/learn/v1/video/history', data)

    API.reqNotice = (data) => ajax.get("/learn/v1/placard/search", data)

    API.reqLiveCourse = (data) => ajax.post(`/learn/v1/course/live/info?courseId=${data.courseId}&courseSemester=${data.courseSemester}`)

    // 获取学习总时长
    API.reqLearnTotalDuration = (courseId) => ajax.get(`/learn/v1/statistics/learntime/total/${courseId}`)

    /**
     * 保存视频播放记录
     * @param {string} chapterId 章id
     * @param {string} courseId 课程id
     * @param {string} sectionId 节id
     * @param {string} subsectionId 小节id
     * @param {string} videoId 视频id
     * @param {string} watchTime 观看时间
     */
    API.saveVideoHistory = (data) => ajax.post('/learn/v1/video/history' + (data.courseSemester ? ('?courseSemester=' + data.courseSemester) : ''), data)

    /**
     * 更新视频播放记录
     */
    API.updateVideoHistory = (data) => ajax.get('/learn/v1/video/history/update', data)

    /**
     * 首页推荐课程-微课
     * @param {number} type 1-为你推荐（微课），2-为您推荐（全部课程）
     */
    API.getRecommendCourse = (data) => ajax.get('/learn/v1/course/recommended/courses', data)
    /**
     * 首页课程知识点推荐
     * @param {*} user_code
     * @param {*} rec2_type
     */
    API.reqHomePageRecommend = (data) => ajax.get('/recs/v1/data/course/recommend2/', data)
    /**
     * 获取课程作业列表提交状态
     */
    API.reqHomeworkList = (data) => ajax.get('/exam-api/submit/resource/submit-info', data)
    /**
     * 获取课件截图列表
     * @param {string} contentId
     */
    API.reqCoursePictureList = (data) => ajax.get('/rman/v1/entity/file/group/info', data)
    /**
     * 关注教师
     * @param {string} fansCode 粉丝code
     * @param {string} teacherCode 教师code
     */
    // API.reqTeacherConcern = (data) => ajax.post('/learn/v1/teacher/homepage/add/fans', data)
    /**
     * 取消关注教师
     * @param {string} fansCode 粉丝code
     * @param {string} teacherCode 教师code
     */
    // API.reqCancelConcern = (data) => ajax.post('/learn/v1/teacher/homepage/delete/fans', data)
    /**
     * 查询是否是老师粉丝
     * @param {*} data
     * @returns
     */
    API.reqIsFans = (data) => ajax.post('/learn/v1/teacher/homepage/teacher/fans', data)

    /**
     * 关注或取消关注
     */
    API.reqFollowOrCancel = (data) => ajax.post(`/learn/v1/teacher/homepage/follow/or/unfollow/${data.userCode}`, { data })
    /**
     * 教师全局搜索
     * @param {string} keyWord 关键词
     * @param {number} page
     * @param {number} size
     */
    API.reqSearchTeacher = (data) => ajax.get('/learn/v1/course/global/data/search', data)
    // 问答相关
    /**
     * 新增问答
     */
    API.addQuestion = (data) => ajax.post('/forumservice/ForumBase/Topic/', data)
    /**
     * 删除问答
     */
    API.deleteQuestion = (data) => ajax.post('/forumservice/ForumBase/Topic/delete/', data)
    /**
     * 查询问答
     */
    API.reqQuestion = (data) => ajax.get('/forumservice/ForumBase/Topic/', data)
    /**
     * 添加评论
     */
    API.addComment = (data) => ajax.post('/forumservice/ForumBase/Comment/', data)
    /**
     * 删除评论
     */
    API.deleteComment = (data) => ajax.post('/forumservice/ForumBase/Comment/delete/', data)
    /**
     * 查询评论
     */
    API.reqComment = (data) => ajax.get('/forumservice/ForumBase/Comment/', data)
    /**
     * 添加回复
     */
    API.addReply = (data) => ajax.post('/forumservice/ForumBase/Reply/', data)
    /**
     * 查询回复
     */
    API.reqReply = (data) => ajax.get('/forumservice/ForumBase/Reply/', data)
    /**
     * 删除回复
     */
    API.deleteReply = (data) => ajax.post('/forumservice/ForumBase/Reply/delete/', data)
    /**
     * 获取头像
     */
    API.reqAvatarList = (data) => ajax.post('/forumservice/ForumBase/UserAvatar/list/', data)
    /**
     * 标记已读
     */
    API.updateRead = (data) => ajax.post('/forumservice/ForumBase/mark_read/', data)

    /**
     * 查询课堂回看所有画面
     */
    API.reqVideoReviewFrame = (data) => ajax.get('/learn/v1/course/frame/all', data)

    /**
     * 设置单个节次公开画面
     */
    API.reqSetFramePublic = (data) => ajax.post('/learn/v1/course/frame/section', data)

    /**
     * 批量设置公开画面
     */
    API.reqSetFramePublicBatch = (data) => ajax.post(`/learn/v1/course/frame/batch?courseId=${data.courseId}`, data.data)

    /**
     * 获取消息列表
     */
    API.reqMessageList = (data) => ajax.get('/unifiedplatform/v1/message/notify/self/list', data)
    /**
     *
     * 获取未读消息的个数
     */
    API.reqUnreadMessageCount = (data) => ajax.get('/unifiedplatform/v1/message/notify/unread/count', data)

    /**
     *
     * @param {*} data
     * @returns
     */
    API.updateMessageRead = (data) => ajax.get('/unifiedplatform/v1/message/read', data)

    /**
     * 查看证书
     */
    API.reqCertification = (data) => ajax.get(`/learn/v1/certificate/student/info/${data.courseId}`, data)

    /**
     *
     * 获取证书详情图片
     */
    API.reqCertificationImage = (data) => ajax.blob('/learn/v1/certificate/info/images', data)

    API.reqTeachers = (data) => ajax.get(`/learn/v1/teaching/course/get/teacher/list`, data)

    /**
     * 获取微课相关推荐
     * @param {*} courseId
     */
    API.reqMicroRecommenList = (data) => ajax.get(`/learn/v1/course/about/courses`, data)

    /**
     * 查询文件详情
     * @param {String[]} videoId
     */
    API.reqFileInfo = (data) => ajax.post('/learn/v1/course/file/info', data)

    /**
     *更新或新增微课视频学习记录
     */
    API.reqMicroStudyRecord = (data) => ajax.post(`/learn/v1/student/study/micro/insert/record?courseId=${data.courseId}&videoId=${data.videoId}&videoName=${data.videoName}`, data)

    /**
     * 微课页获取教师mooc课程数量
     */
    API.reqteacherMoocList = (data) => ajax.get(`/learn/v1/teaching/course/get/courses/list`, data)

    /**
     * 微课页获取教师微课课程数量
     */
    API.reqteacherMicroList = (data) => ajax.post(`/learn/v1/course/release?isCreate=false`, data)

    /**
     * 首页获取系统通知列表
     */
    API.reqNotifacationList = (data) => ajax.get(`/unifiedplatform/v1/msg/display`, data)

    /**
     * 获取系统通知详情
     * @param {*} id
     */
    API.reqNotifacationDetail = (data) => ajax.get(`/unifiedplatform/v1/msg/details`, data)

    /**
     * 直播校验密码
     */
    API.reqValidateLivePassword = (data) => ajax.get(`/learn/live/verify`, data)

    /**
     * 直播互动
     */
    API.reqLiveInteractionAdd = (data) => ajax.post(`/learn/v1/live/interaction/add`, data)

    /**
     * 活动直播统计观看时长
     * @param {*} college
     * @param {*} collegeName
     * @param {*} liveId
     * @param {*} liveName
     * @param {*} studentCode
     * @param {*} studentName
     * @param {*} watchDuration 单位s
     * @returns
     */
    API.reqLiveStatisticsWatchTime = (data) => ajax.post('/learn/v1/course/live/addOrUpdateDuration', data)

    /**
     *分页查询直播互动数据
     * http://localhost:8090/learn/swagger-ui.html?urls.primaryName=%E9%87%8D%E6%9E%84%E7%9B%B8%E5%85%B3%E6%8E%A5%E5%8F%A3%E6%96%87%E6%A1%A3#/%E7%9B%B4%E6%92%AD%E4%BA%92%E5%8A%A8API/queryByPageUsingGET_4
     */
    API.reqLiveInteractionList = (data) => ajax.get(`/learn/v1/live/interaction/query/page`, data)

    /**
     * 删除評論
     * http://localhost:8090/learn/swagger-ui.html?urls.primaryName=%E9%87%8D%E6%9E%84%E7%9B%B8%E5%85%B3%E6%8E%A5%E5%8F%A3%E6%96%87%E6%A1%A3#/%E7%9B%B4%E6%92%AD%E4%BA%92%E5%8A%A8API/deleteByIdUsingGET_1
     */
    API.reqLiveInteractionDelete = (data) => ajax.get(`/learn/v1/live/interaction/delete/${data.id}`, data)

    // 分离接口相关
    /**
     * 查询相关课程
     * @param data
     * @returns {Promise<unknown>}
     */
    API.reqAboutCourse = (data) => ajax.get(`/learn/v1/homepage/about/course`, data)
    API.reqRecommendAboutCourse = (data) => ajax.get(`/learn/v1/homepage/recommend/about/course`, data)
    /**
     * 查询课程大纲
     * @param courseId 课程id
     * @param type 查询类型: released：待发布的数据 为空：查询已发布的数据 默认为空
     */
    API.reqChapterTree = (data) => ajax.get(`/learn/v1/homepage/chapter/info`, data)
    /**
     * 微课 查询语音文本、学习笔记、学习人数、评论、打分
     * @param courseId
     */
    API.reqMicroExtendInfo = (data) => ajax.get('/learn/v1/homepage/micro/extend/info', data)
    /**
     * preview页面 查询教学团队
     * @param data
     * @returns {Promise<unknown>}
     */
    API.reqTeacherTeam = (data) => ajax.get('/learn/v1/homepage/teacher/team', data)
    /**
     * 获取语音文本列表
     * @param videoId
     */
    API.reqVoiceText = (data) => ajax.get('/learn/v1/homepage/video/text', data)
    /**
     * 获取教师课程数量
     * @param teacher
     */
    API.reqTeacherCourseNumber = (data) => ajax.get(`/learn/v1/course/teacher/search`, data)
    /**
     * 统计资源下载次数
     * @param courseId
     * @param resourceId
     */
    API.reqResourceDownloadNumber = (data) => ajax.get('/learn/v1/student/study/resource/download', data)

    /**
     * 获取教师信息
     * @param teacherCode
     */
    API.reqTeacherInfo = (data) => ajax.get(`/learn/v1/teacher/homepage/info?teacherCode=${data.teacherCode}`)

    /**
     * preview页面获取参与数量
     */
    API.reqJoinNumber = (data) => ajax.get(`/learn/v1/homepage/course/join`, data)

    /**
     * 获取用户课程评价信息
     * @param courseId
     */
    API.reqEvaluationInfo = (courseId) => ajax.get(`/learn/v1/evaluation/user/${courseId}`)

    /**
     * 笔记截图抽帧
     * @param contentId
     * @param ns100
     * @param noteId
     */
    API.reqNoteScreenshot = (data) => ajax.post(`/edudatacenter/v1/learning-note-service/flow`, data)

    /**
     * 查询笔记抽帧
     * @param contentId
     * @param noteId
     */
    API.reqNoteScreenshotStatus = (data) => ajax.get(`/edudatacenter/v1/learning-note-service/screenshot`, data)

    /**
     * 资源库获取标签列表
     */
    API.reqTagList = (type) => ajax.get(`/learn/resources/labels?type=${type}`)

    /**
     * 课程地图引用
     * @param Array [id]
     */
    API.reqCoursemapQuote = (data) => ajax.post('/learn/m1/knowledge/batch/quote', data)

    /**
     * 课程资源包引用获取targetId
     * @param id
     */
    API.reqShareToPerson = (id) => ajax.post(`/learn/v1/curriculum/center/share/to/personal/${id}`)

    /**
     * 课程资源包引用
     * @param orgCourseId
     * @param targetCourseId
     */
    API.reqCourseResourceQuote = (data) => ajax.post('/exam-api/template/homework/quote', data)
    /**
     * 修改mooc问答公开状态
     */
    API.updateQaStatus = (data) => ajax.post("/forumservice/ForumBase/Topic/permissions/", data)
    /**
     * 课程资源收藏
     * @param contentId_
     */
    API.reqCourseResourceCollect = (contentId_) => ajax.post(`/rman/v1/metadata/resource/collection?contentId=${contentId_}`)

    /**
     * 课程资源取消收藏
     * @param contentIds
     */
    API.reqCourseResourceUncollect = (contentIds) => ajax.post(`/rman/v1/metadata/resource/delete/collection`, contentIds)

    /**
     * 课程资源点赞
     * @param {*} contentId
     * @returns
     */
    API.reqCourseResourceLike = (contentId) => ajax.post(`/rman/v1/entity/like?contentId=${contentId}`)

    /**
     * 课程资源取消点赞
     * @param {*} contentId
     * @returns
     */
    API.reqCourseResourceUnLike = (contentId) => ajax.post(`/rman/v1/entity/cancel/like?contentId=${contentId}`)


    /**
     * 获取 资源管理 模块的全局参数
     */
    API.reqRmanGlobalParam = () => ajax.get('/unifiedplatform/v1/app/app/module/parameter/list?moduleCode=zyzx')

    /**
     * 资源库获取分享用户列表
     * @param page
     * @param size
     * @param keyword
     */
    API.reqShareUserList = (data) => ajax.get(`/unifiedplatform/v1/base/data/database/source/data?sourceTpye=0&school=EDU&roleCodes=r_teacher,r_course_manager,admin_S1,r_resource_manager,r_sys_manager&pageIndex=${data.page}&pageSize=${data.size}&keyWord=${data.keyword || ''}`)

    /**
     * 资源库分享链接
     */
    API.reqResourceShareLink = (data) => ajax.post(`/rman/v1/share/create/share/link`, data)

    /**
     * 资源库分享给系统用户
     */
    API.reqResourceShareUser = (data) => ajax.post(`/rman/v1/share/create/user/share/link`, data)

    /**
     * 资源库获取文件夹列表
     */
    API.reqFolderList = (level) => ajax.get(`/rman/v1/folder/all/tree?level=${level}`)
    /**
     * 获取子文件夹
     */
    API.reqFolderPath = (path, isOwner) => ajax.get(`/rman/v1/folder/children?folderPath=${encodeURIComponent(path)}%2F&isChildCount=true${isOwner ? '&isOwner=true' : ''}`)

    /**
     * 资源库复制资源
     */
    API.reqResourceCopy = (data) => ajax.post(`/rman/v1/entity/copy`, data)

    /**
     * 判断是否有互动
     */
    API.reqCourseInteractiveList = (courseId) => ajax.get(`/classroom/webCh/courseTree?courseId=${courseId}`)

    /**
     * 获取问答列表
     */
    API.reqCourseQaList = (data) => ajax.get(`/forumservice/ForumBase/Topic/`, { page: 1, size: data.size, link_id: data.courseId, height: 1, user_id_of_unread: data.userCode })

    /**
     * 新增搜索记录
     * @param {string} name
     * @returns
     */
    API.reqSearchHistoryAdd = (data) => ajax.post('/learn/v1/search/history/add', data)

    /**
     * 查询搜索记录
     * @param {string} name
     */
    API.reqSearchHistoryList = (data) => ajax.get('/learn/v1/search/history/list', data)

    /**
     * 删除搜索记录
     * @param {array} ids
     * @returns
     */
    API.reqSearchHistoryDel = (data) => ajax.post('/learn/v1/search/history/delete', data)

    /**
     * 检索关键词联想
     * @param {string} name
     */
    API.reqKeywordLenovoList = (data) => ajax.get('/learn/v1/search/history/Keywords/lenovo', data)

    /**
     * 获取搜索热词
     */
    API.reqHotKeyword = (data) => ajax.get('/learn/v1/search/history/portal/hot/list', data)

    /**
     * 搜索页查询教师
     * @param name
     * @param page
     * @param size
     */
    API.reqSearchTeacherList = (data) => ajax.get(`/learn/v1/search/history/search/teacher`, data)

    /**
     * 通过教师查询课程列表
     */
    API.reqTeacherCourseList = (data) => ajax.post(`/learn/v1/course/release?courseState=0&isCreate=false`, data)

    /**
     * 搜索页获取课堂回看列表
     */
    API.reqSearchCourseBackList = (data) => ajax.get(`/learn/v1/search/history/search/course/back`, data)

    /**
     * 搜索页获取直播列表
     */
    API.reqSearchLiveList = (data) => ajax.get(`/learn/v1/search/history/search/live`, data)

    /**
     * 查询spoc/mooc课程信息
     * @param courseId
     */
    API.reqCourseInfo = (data) => ajax.get('/learn/v1/course/info', data)

    //展会需求 涨知识 start
    /**
     *
     */
    API.reqAllKnowladgeList = (data) => ajax.postQuery(`/rman/v1/search/knowledge/point`, data)

    API.reqVideoDetail = (data) => ajax.get(`/rman/v1/entity/base/${data}`)
    //展会需求 涨知识 end
    /**
     * 数据采集（注意只有微课和mooc需要采集信息，mooc的教师只采集负责老师和主讲老师）
     * {
     *   "type": "edu.user_course",
     *   "content": {
     *       "user_code": "202201",
     *       "teacher_codes": [
      *      "202201", "12"
     *       ],
     *       "subject_code": "学科code",
     *       "college_code": "学院code"
     *      }
     *   }
     */
    API.reqCourseUserGather = (data) => ajax.post('/dcps/v1/data/collection/', data)

    /**
     * 查询教师课堂回看数据
     */
    API.reqTeacherCourseBackData = (data) => ajax.get('/learn/v1/course/record/course/private/authority/course', data)

    /**
     * 查询智能小节
     */
    API.reqResourceAnalysis = (data) => ajax.get(`/learn/resource/analysis/get/${data.videoId}`)

    /**
     * 查询五大专题图书资源
     */
    API.reqPlateLibraryList = (data) => ajax.post(`/learn/v1/plateLibrary/list`, data)

    /**
     * 首页获取五大专题课程信息
     */
    API.reqHomedachuanPlateList = () => ajax.get('/learn/v1/dachuanplate/config/detail/list')

    /**
     * 查询视频知识点
     */
    API.reqKnowladgePoint = (data) => ajax.get('/learn/v1/homepage/knowledge/info', data)

    /**
     * 通过邀请码和课程id进行加入
     */
    API.reqJoinSpoc = (data) => ajax.get(`/learn/course/invitation/join`, data)

    /**
     * 查询当前用户是否是直播班级课成员
     */
    API.reqIfCourseLive = (data) => ajax.get('/learn/v1/teaching/get/live/member', data)

    /**
     * 全局搜索获取知识点列表
     */
    API.reqSearchKnowledgePoint = (data) => ajax.get('/learn/v1/search/history/knowledge/point', data)

    /**
     * 全局搜索微课列表
     */
    API.reqSearchMicroList = (data) => ajax.get('/learn/v1/search/history/micro', data)

    /**
     * 查询课程关键词和摘要
     */
    API.reqKeywordAndAbstract = (data) => ajax.get('/learn/v1/homepage/course/keywordAndAbstract', data)

    /**
     * 直播开启翻译
     */
    API.reqLiveTransitionOpen = (data) => ajax.get('/learn/wsman/TS/start/', data)

    /**
     * 直播开启同声传译
     */
    API.reqLiveVoiceTransitionOpen = (data) => ajax.get('/learn/wsman/TTS/start/', data)

    /**
     * 获取语音文本是否确认
     */
    API.reqVoiceTextConfirm = (data) => ajax.post('/learn/v1/homepage/resource/info', data)

    /**
     * 课程资源包检索
     */
    API.reqResourceSearch = (data) => ajax.get('/learn/v1/homepage/course/template/resources', data)

    /**
     * 课程地图检索
     */
    API.reqMapSearch = (data) => ajax.get('/learn/v1/homepage/map/search', data)

    /**
     * 多媒体资源检索
     */
    API.reqMediaSearch = (data) => ajax.get('/learn/v1/homepage/multimedia/resources', data)

    /**
     * 通过知识点Id查询知识点片段分组检索资源、图谱、课程、课程包、资源
     */
    API.reqKnowledgePointFrom = (data) => ajax.get('/learn/v1/homepage/search/point', data)

    /**
     * 敏感词检测
     */
    API.reqSensitiveWord = (value, text, successCallback = () => { }, failedCallback = () => { }) => {
        if (value !== "") {
            return ajax.get('/sensitiveword/match', { detectionText: value.replace(RegExp("<.+?>", "g"), "") }).then((res) => {
                if (res.statusCode === 200 && res.data?.length === 0) {
                    return successCallback();
                } else if (res.data?.length > 0) {
                    return global.Vue.prototype.$confirm(`<svg width="1.4em" height="1.4em" fill="#faad14" aria-hidden="true" focusable="false" style="margin-right: 12px;">
                    <use xlink:href="#iconwarning-circle"></use>
                </svg>${text}包含敏感词："${Array.from(new Set(res.data.map((item) => item.matchKeyword))).join("、")}"，确认继续执行吗？`, '', { showClose: false, dangerouslyUseHTMLString: true, customClass: 'sensitive_word_modal' }).then(() => {
                        return successCallback()
                    }).catch(() => {
                        return Promise.reject()
                    })
                }
            })
        } else {
            return Promise.resolve(successCallback())
        }
    }

    /**
     * 课堂回看设置谁可以看
     */
    API.reqCourseBackAuthority = (data) => ajax.post('/learn/v1/course/bulk/update/authority?authority=' + data.authority, data.courseIds)

    /**
     * 弹题获取版本信息
     */
    API.reqVideoQuestionVersion = (data) => ajax.get('/rman/v1/question/selected/version', data)
    /**
     *
     * 弹题获取所有点位
     */
    API.reqVideoQuestionPoint = (data) => ajax.get('/rman/v1/question/in/point', data)
    /**
     * 弹题获取题目列表
     */
    API.reqVideoQuestionList = (data) => ajax.get('/rman/v1/question/selected/version/bank', data)
    /**
     * 通过id获取试题列表
     */
    API.reqQuestionListById = (data) => ajax.post('/exam-api/examination/getQuestionsByIds', data)
    /**
     * 提交互动试题
     */
    API.reqSubmitQuestion = (data) => ajax.post('/rman/v1/question/answer', data)
    /**
     * 查询课程是否加入
     */
    API.reqIsJoinCourse = (data) => ajax.get('/learn/v1/course/join', data)
    /**
     * 查询课程期次信息
     */
    API.reqCourseSemester = (data) => ajax.get('/learn/v1/teaching/semester', data)
    /**
     * chatglm查询关键词解析
     */
    API.reqKeywordChatGlm = (data) => ajax.post('/rman/v1/intelligent/chat/glm', data)
    /**
     * 直播预约
     */
    API.reqLiveReservation = (data) => ajax.post('/livemanage/v1/general-schedule/reservation/add/', data)
    /**
     * 直播取消预约
     */
    API.reqLiveReservationCancel = (data) => ajax.post('/livemanage/v1/general-schedule/reservation/cancel/', data)
    /**
     * 获取教学资源库资源统计数据
     */
    API.reqResourceStatistics = (data) => ajax.get('/statistic/ResourceStatistic/type', data)
    /**
     * 获取教学资源库知识图谱总量统计
     */
    API.reqKnowledgeMapTotal = (data) => ajax.get('/learn/m1/knowledge/count', data)
    /**
     * 获取用户信息，西工大token对接
     */
    API.reqUserTokenInfo = (data) => ajax.get('/unifiedplatform/v1/user/current', data)
    /**
     * 获取课件截图列表
     */
    API.reqCoursewareImgList = (data) => ajax.get('/rman/v1/entity/file/screenshot', data)
    /**
     * 以图搜图-发起人脸识别
     */
    API.reqStartSearchPicture = (data) => ajax.get('/rman/v1/intelligent/initiate/face-image', data)
    /**
     * 以图搜图-查询人脸识别结果
     */
    API.reqSearchPicture = (data) => ajax.get('/rman/v1/intelligent/face-image', data)
    /**
     * 以图搜图-获取列表
     */
    API.reqSearchPictureList = (data) => ajax.post(`/learn/v1/course/search/images?page=${data.page}&size=${data.size}`, data.imagesIds)
    /**
     * 获取访问统计数据
     */
    API.reqVisiteStatistics = (data) => ajax.get('/statistic/UserStatistic/equipment', data)
    /**
     * 获取直播ppt课件资源
     */
    API.reqLivePpt = (data) => ajax.get('/livemanage/v1/general-schedule/man/detail/', data)
    /**
     * 判断课程资源是否已删除
     */
    API.reqCourseResourceExist = (data) => ajax.get(`/learn/v1/course/resource/exist/${data.courseId}`, data)
    /**
     * 获取模块控制开关
     */
    API.reqModuleConfig = () => ajax.get('/unifiedplatform/v1/app/app/module/enabled/list')
    /**
     * 上传笔记截图
     */
    API.reqUploadNoteImg = (data) => ajax.post('/edudatacenter/v1/learning-note-service/image/save?courseId=' + data.courseId, data.imgs)
    /**
     * 查询学习资讯数据
     */
    API.reqLearnInfomation = (data) => ajax.get('/unifiedplatform/v1/info-config/query', data)
    /**
     * 获取资源笔记章节信息
     */
    API.reqNoteChapter = (data) => ajax.get('/edudatacenter/v1/learning-note-service/chapter', data)
    /**
     * 下载笔记
     */
    API.reqNoteDownload = (data) => ajax.post('/edudatacenter/v1/learning-note-service/download', data)
    /**
     * 微课学习统计
     */
    API.reqMicroStudy = (data) => ajax.get('/learn/v1/student/study/micro/study', data)
    /**
     * 高级检索来源数据
     */
    API.reqHighRetrievalSource = () => ajax.get('/rman/v1/search/source')
    /**
     * 获取在线课堂列表
     */
    API.reqCourseReviewList = (data) => ajax.get(`/learn/v1/course/video/review/${data.type || -1}`, data)
    /**
    * 西工大用户分页查询课程案例库
    */
    API.reqCaseStore = (data) => ajax.get('/learn/teaching/case/library/list', data)
    /**
     * 西工大查询教学案例详情
     */
    API.reqCaseDetail = (id) => ajax.get(`/learn/teaching/case/library/find/by/${id}`)
    /**
     * 西工大教学案例学院分组列表
     */
    API.reqCollegeList = () => ajax.get(`/learn/teaching/case/library/college/list`)
    /**
     * 点播资源检索
     */
    API.reqVideoUrl = (data) => ajax.post(`/learn/v1/course/getVideoUrl`, data, { apikey: 'fa676f13-faab-4052-9fc8-9498603e7121' })
    /**
     * 通过课序号查询课程详情
     */
    API.reqCourseInfoBySerialNo = (data) => ajax.get('/ipingestman/schedule/course_loop/reservation/list', data)
    /**
     * 统计课程点击量
     */
    API.reqCourseViewCount = (data) => ajax.post('/learn/v1/learningsituation/course/view', data)
    /**
     * 获取首页推荐课程
     */
    API.reqHomeRecommendCourse = () => ajax.get('/learn/v1/course/homepage/search')
    /**
     * 首页查询统计数据
     */
    API.reqHomeCourseStatistics = () => ajax.get('/learn/v1/statistics/homepage/courseauser')
    /**
  * 陕西商贸首页统计数据
  */
    API.resourceStatisticData = () => ajax.get('/statistic/ResourceStatistic/public/type')
    /**
     * 陕西商贸获取图书列表
     */
    API.reqLiterature = (data) => ajax.get('/pycustomizedservice/sxtc/literature/', data)
    /**
     * 陕西商贸文献统计点击量
     */
    API.reqLiteratureClick = (data) => ajax.post('/pycustomizedservice/sxtc/literature/', data)
    /**
     * 模块访问统计
     */
    API.reqModuleVisited = (data) => ajax.post('/unifiedplatform/v1/user/browse/record', data)
    /**
     * 退出登录
     */
    API.reqLogOut = (data) => ajax.get('/unifiedlogin/v1/loginmanage/loginout/go', data)
    /**
     * 自定义url获取数据
     */
    API.reqDataByCustomUrl = (url) => ajax.get(url)
    /**
     * 上科或者新闻、学术活动
     */
    API.reqShTechNewsOrActivity = (domainId, columnId) => ajax.get(`/learn/shanghai/tech/news/academic/activities?domainId=${domainId}&columnId=${columnId}`)
    /**
     * 上科查询教学组织推荐、热门课程
     * { college: 学院id, initial:首字母, page: 页码, size: 每页数量,semester: 学年学期 }
     */
    API.reqShTechTeachOrgCourse = (data) => ajax.get('/learn/shanghai/tech/get/course', data)
    /**
     * 上科首页获取课程中心学年学期配置项
     */
    API.reqShTechHomePageSemester = () => ajax.get('/learn/shanghai/tech/get/course')
    /**
     * 上科门户查询资源数量
     */
    API.reqShTechHomePageResource = () => ajax.get('/learn/shanghai/tech/resource/count')
    /**
     * 上科本科生课程详情查询
     */
    API.reqShTechBKCourseDetail = (semester, term, course_no, course_id) => ajax.get(`/shanghaitechdatasync/datasync/bksCourse/?semester=${semester}&term=${term}&course_no=${course_no}&course_id=${course_id}`)
    /**
     * 上科本科生开课历史查询
     */
    API.reqShTechBKOpenCourseHistory = (course_id) => ajax.get(`/shanghaitechdatasync/datasync/bksCourseHistory/?course_id=${course_id}`)
    /**
     * 上科研究生课程详情查询
     */
    API.reqShTechYJSCourseDetail = (semester, term, course_no, course_id) => ajax.get(`/shanghaitechdatasync/datasync/yjsCourse/?semester=${semester}&term=${term}&course_no=${course_no}&course_id=${course_id}`)
    /**
     * 教学大纲查询（本科生/研究生课程详情接口里面没有教学大纲时才使用此接口）
     */
    API.reqShTechCourseJXDG = (course_code) => ajax.get(`/shanghaitechdatasync/datasync/newJxdg/?course_code=${course_code}`)
    /**
     * 上科研究生开课历史查询
     */
    API.reqShTechYJSOpenCourseHistory = (course_id) => ajax.get(`/shanghaitechdatasync/datasync/yjsCourseHistory/?course_id=${course_id}`)
    /**
     * 上科通过课序号反查课程id、录播id
     * [{courseNumber: 课程代码, semester: 学年学期, serialNumber:课序号 }]
     */
    API.reqShTechCourseIdByCourseNo = (data) => ajax.post(`/learn/shanghai/tech/get/back/course`, data)
    /**
     * 上科获取本科学院类别
     */
    API.reqShTechBkSubject = () => ajax.get('/shanghaitechdatasync/datasync/category/')
    /**
     * 上科首页获取教学楼、教室
     */
    API.reqShTechHomePageClassroom = () => ajax.get('/ipingestman/area_tree/')
    /**
     * 上科首页获取教学楼、教室
     */
    API.reqShTechHomePageTimeTable = (jxl_id, js_id, class_date) => ajax.get(`/ipingestman/schedule/supervision/timetable_list?jxl_id=${jxl_id}&js_id=${js_id}&class_date=${class_date}`)
    /**
     * 上科获取培养方案学院
     */
    API.reqShTechTeachPlanCollege = (code) => ajax.get(`/learn/shanghai/tech/organization/subject?organization=${code}`)
    /**
     * 上科获取本科生培养方案
     */
    API.reqShTechBkTeachPlan = (profession, semester, id) => ajax.get(`/shanghaitechdatasync/datasync/bksProgram/?profession=${profession}&semester=${semester}&id=${id}`)
    /**
     * 上科获取本科生培养方案列表
     */
    API.reqShTechBkTeachPlanList = (profession, semester) => ajax.get(`/shanghaitechdatasync/datasync/bks_program_select/?profession=${profession}&semester=${semester}`)
    /**
     * 上科获取研究生培养方案
     */
    API.reqShTechYJSTeachPlan = (profession, semester, id) => ajax.get(`/shanghaitechdatasync/datasync/yjsProgram/?profession=${profession}&semester=${semester}&id=${id}`)
    /**
     * 获取门户免责声明
     */
    API.reqDisclaimerInfo = () => ajax.get('/unifiedplatform/v1/disclaimer/getdisclaimercontent')
    /**
     * 门户免责声明标为已读
     */
    API.reqConfirmDisclaimer = () => ajax.post('/unifiedplatform/v1/disclaimer/browsedisclaimer')
    /**
     * 获取直播回看资源
     */
    API.reqLiveBackResource = (data) => ajax.post('/rman/v1/search/all', data)
    /**
     * 上科获取具体学院下研究生的所有具有培养方案的专业
     */
    API.reqShTechYJSTeachPlanProfession = (code, semester) => ajax.get(`/shanghaitechdatasync/datasync/yjsProfessionOnlyProgram/?college_code=${code}&semester=${semester}`)
    /**
     * 上科研究生通过学院获取培养方案列表
     */
    API.reqShTechYJSPlanListByCollege = (profession, semester) => ajax.get(`/shanghaitechdatasync/datasync/yjs_program_select/`, { profession, semester })
    /**
     * 上科获取具体学院下本科生的所有具有培养方案的专业
     */
    API.reqShTechBKTeachPlanProfession = (code, semester) => ajax.get(`/shanghaitechdatasync/datasync/bksProfessionOnlyProgram/?college_code=${code}&semester=${semester}`)
    /**
     * 获取教学组织
     */
    API.reqOrgnazition = () => ajax.get(`/learn/courseSearch?isHome`)
    /**
     * 上科首页随机获取一个有课程的教室
     */
    API.reqShTechHomePageRandomClassroom = () => ajax.get(`/ipingestman/schedule/supervision/get_has_timetable_area/`)
    /**
     * 上科课程页面获取课程列表
     */
    API.reqShTechCourseList = (data) => ajax.get('/learn/shanghai/tech/get/course', data)
    /**
     * 查询课程
     */
    API.reqCourseList = (data) => ajax.get('/learn/provincial/index/search', data)
    /**
     * 查询最热课程
     */
    API.reqCourseListHot = (data) => ajax.get('/learn/provincial/index/search?field=hits', data)
    /**
     * 查询微课资源
     */
    API.reqCourseListMin = (data) => ajax.get('/learn/v1/homepage/multimedia/resources', data)
    /**
     * 上科资源中心查询开放课程
     */
    API.reqCourseCenterOpenCourse = (extraUrl) => ajax.get(`/shanghaitechdatasync/datasync/moocCourse/${extraUrl}`)
    /**
     * 上科资源中心查询课程地图
     */
    API.reqCourseCenterCourseMap = (extraUrl) => ajax.get(`/learn/v1/homepage/map/search${extraUrl}`)
    /**
     * 上科资源中心开放课程学科领域列表
     */
    API.reqCourseCenterOpenCourseSubject = () => ajax.get(`/shanghaitechdatasync/datasync/moocCourseCategory/`)
    /**
     * 上科资源中心知识点
     */
    API.reqCourseCenterKnowledge = (extraUrl) => ajax.get(`/rman/v1/resourcecentre/searchknowledgepointlist${extraUrl}`)
    /**
     * 上科资源中心多媒体资源
     */
    API.reqCourseCenterMedia = (extraUrl) => ajax.get(`/rman/v1/resourcecentre/searchresourcelist${extraUrl}`)
    /**
     * 上科资源中心软件工具
     */
    API.reqCourseCenterSoftware = (extraUrl) => ajax.get(`/rman/v1/resourcecentre/searchsoftwaretools${extraUrl}`)
    /**
     * 上科资源中心开放源码
     */
    API.reqCourseCenterOpenCode = (extraUrl) => ajax.get(`/rman/v1/resourcecentre/searchDemoAsync${extraUrl}`)
    /**
     * 上科资源中心文献
     */
    API.reqCourseCenterLiterature = (extraUrl) => ajax.get(`/rman/v1/resourcecentre/getPnxsAsync${extraUrl}`)
    /**
     * 上科AI应用AI助手列表
     */
    API.reqAiAssistant = (extraUrl) => ajax.get(`/terminator/api/v1/application/${extraUrl}`)
    /**
     * 上科AI应用课程地图
     */
    API.reqAiAssistantCourseMap = (extraUrl) => ajax.get(`/learn/m1/knowledge/query/page${extraUrl}`)
    /**
     * 上科资源中心教学资源检索
     */
    API.reqCourseCenterTeachingResource = (extraUrl) => ajax.get(`/rman/v1/resourcecentre/searchteachingresource${extraUrl}`)
    /**
     * 上科资源中心获取最新发布
     */
    API.reqCourseCenterLatestRelease = (extraUrl) => ajax.get(`/rman/v1/resourcecentre/getnewpublishranks${extraUrl}`)
    /**
     * 上科资源中心获取热点资源
     */
    API.reqCourseCenterHotResource = (extraUrl) => ajax.get(`/rman/v1/resourcecentre/getmorebrowseranks${extraUrl}`)
    /**
     * 获取活动直播
     */
    API.reqActivityLive = (extraUrl) => ajax.get(`/learn/app/live/search${extraUrl}`)
    /**
     * 播放器版权水印配置
     */
    API.reqPlayerWatermark = () => ajax.get(`/unifiedplatform/v1/setting/watermark`)
    /**
     * 上科资源中心记录资源浏览数
     * 均为可选，有则传
     * type：资源类型；mainId：资源id；eexId：知识节点id；name：资源名称；url：第三方链接；inpoint：地图入口id；outpoint：地图出口id；
     */
    API.postResourceViewCount = (data) => ajax.post(`/rman/v1/resourcecentre/resoursebrowse`, data)
    /**
     * 上科大获取研究生某一门课的课表
     * semester: 学年；term: 学期；course_no: 课程序号；times: 周次
     */
    API.reqShTechYJSCourseSchedule = (semester, term, course_no, times) => ajax.get(`/shanghaitechdatasync/datasync/yjsCourseTimeTable/?semester=${semester}&term=${term}&course_no=${course_no}&times=${times}`)
    /**
     * 上科大获取本科生某一门课的课表
     * semester: 学年；term: 学期；course_no: 课程序号；times: 周次
     */
    API.reqShTechBKCourseSchedule = (semester, term, course_no, times) => ajax.get(`/shanghaitechdatasync/datasync/bksCourseTimeTable/?semester=${semester}&term=${term}&course_no=${course_no}&times=${times}`)
    /**
     * 获取当前教学周
     */
    API.reqCurrentWeek = () => ajax.get(`/ipingestman/schedule/supervision/current_semester_teaching_week`)
    /**
     * 上科大检索ArXiv平台文献
     */
    API.reqArXivLiturature = (extraUrl) => ajax.get(`/rman/v1/resourcecentre/searcharxiv${extraUrl}`)
    /**
     * 上科大检索PubMed Central平台文献
     */
    API.reqPubMedCentralLiturature = (extraUrl) => ajax.get(`/rman/v1/resourcecentre/searchpubmedcentral${extraUrl}`)
    /**
     * 上科大检索MedRxiv平台文献
     */
    API.reqMedRxivLiturature = (extraUrl) => ajax.get(`/rman/v1/resourcecentre/searchmedrxiv${extraUrl}`)
    /**
     * 上科大检索ChemRxiv平台文献
     */
    API.reqChemRxivLiturature = (extraUrl) => ajax.get(`/rman/v1/resourcecentre/searchchemrxiv${extraUrl}`)
    /**
     * 上科大检索DOAJ平台文献
     */
    API.reqDOAJLiturature = (extraUrl) => ajax.get(`/rman/v1/resourcecentre/searchDoaj${extraUrl}`)
    /**
     * 上科大获取Blackboard、MOOC学年
     */
    API.reqBlackboardMoocYear = () => ajax.get(`/rman/v1/resourcecentre/getthirdresourcefacet`)
    /**
     * 上科大获取用户可使用的agent
     */
    API.reqUserAgent = (extraUrl) => ajax.get(`/terminator/api/v1/application/aitools${extraUrl}`)
    /**
     * 获取直播列表（服务端渲染改接口请求）
     */
    API.reqLiveList = (data) => ajax.get(`/learn/app/live/search`, data)
    require('./shanghaiTech')
    require('./terminator')
    require('./homework')

    /**
    * 获取图书信息
    */
    API.searchListBook = (data) => ajax.get('/pycustomizedservice/sxtc/searchList/', data)
    /**
    * 获取知行图书信息
    */
    API.zhixingbookslist = (data) => ajax.get('/pycustomizedservice/sxtc/sqlbookslist/', data)
    /**
      * 获取知行图书信息
      */
    API.sxtcbookslist = (data) => ajax.get('/pycustomizedservice/sxtc/book3915list/', data)
    /**
     * sxtc图书点击量计数接口
     */
    API.sxtcbooksCount = (data) => ajax.post('/pycustomizedservice/sxtc/clickOneCount/', data)

    /**
     * 获取课程筛选条件
     */
    API.reqCourseSearchParams = () => ajax.get('/third-api/v1/course-center/search/params')

    /**
     * 获取推荐知识点
     */
    API.reqRecommendKnowledgeList = (data) => ajax.get('/rman/v1/resourcesuggest/suggestknowledgepoint', data)
    /**
     * 知识点浏览记录
     */
    API.reqReconmendKnowledgeView = (data) => ajax.post(`/rman/v1/resourcesuggest/addbrowseresourcerecord?OperateType=0&BrowseResourceType=0&ContentId=${data.contentId}`)
    /**
     * 获取直播回看资源
     */
    API.reqLiveBackResource = (data) => ajax.post('/rman/v1/search/all', data)
    /**
     * 获取词云数据
     */
    API.reqWordCloud = (data) => ajax.get('/rman/v1/intelligent/select/keywords', data)

    /**
     * 获取知识要点
     */
    API.reqKnowledgeEssentials = (data) => ajax.get('/rman/v1/intelligent/select/knowledge/summary', data)

    /**
     * 获取回看是否有观看权限
     */
    API.reqReviewPermission = (data) => ajax.get('/learn/v1/course/have/permission', data)
    /**
    * 获取资源专题
   */
    API.reqResourceCourse = (courseclassification_code, page, size) => ajax.get(`/learn/v1/teaching/course/get/course/config?courseclassification_code=${courseclassification_code}&page=${page}&size=${size}`)
    /**
     * 获取直播回看资源
     */
    API.reqLiveBackResource = (data) => ajax.post('/rman/v1/search/all?duplicate=true', data)
    API.getMoocChapterDetail = (data) => ajax.get(`/learn/v1/teaching/course/get/course/details`, data)
})(window)
